export type ShortcutFormScope = "personal" | "global";

export type ShortcutFormState = {
  id: string;
  trigger: string;
  title: string;
  scope: ShortcutFormScope;
  body: string;
};

export const EMPTY_SHORTCUT_FORM: ShortcutFormState = {
  id: "",
  trigger: "/",
  title: "",
  scope: "personal",
  body: "",
};

export function createEmptyShortcutForm(): ShortcutFormState {
  return { ...EMPTY_SHORTCUT_FORM };
}

export const VARIABLE_TOKENS = ["{{nome}}", "{{telefone}}", "{{curso}}", "{{valor}}"];
